module.exports = __webpack_public_path__ + "name=img/src/assets/icons/ic_github.svg?dead308883313ea0a00fb023158055ca";